import { TextStyleModel } from '../../../Common/PageBuilder/models/text-style.model';
import { DisplayElementModel } from '../../../Common/PageBuilder/models/display-element.model';
import { WireCompanyBioApiModel } from './wire-company-bio-api.model';

export class WireCompanyBioModel extends DisplayElementModel  {
    styles: TextStyleModel = new TextStyleModel();
    companyBio: string;

    constructor(apiModel?: WireCompanyBioApiModel) {
        super();
        if (apiModel) {
            this.companyBio = apiModel.companyBio;
        }
    }

    toApiModel(): WireCompanyBioApiModel {
        return {
            companyBio: this.companyBio?.trim().length > 0 ? this.companyBio : null
        } as WireCompanyBioApiModel;
    }

    clone(): WireCompanyBioModel {
        return new WireCompanyBioModel(this.toApiModel());
    }

    equals(other: WireCompanyBioModel): boolean {
        return this.companyBio === other.companyBio;
    }

    canRender(): boolean {
        return this.companyBio?.trim().length > 0;
    }

    onUpdate(): boolean {
        return true;
    }

    isEqual(other: WireCompanyBioModel): boolean {
        return this.companyBio === other.companyBio;
    }
}
